import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Alert from "./components/Alert";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import configureStore from "./store";
import AppThemeProvider from "./v2/design-system/AppThemeProvider";
import { V2ToggleProvider } from "./context/experienceToggleContext";
import GlobalStyle from "./style";

const store = configureStore();

// if (window !== window.top) {
//   window.top.location.assign(window.location.href);
// }

if (window.top === window.self) {
  ReactDOM.render(
    <Provider store={store}>
      <AppThemeProvider>
        <BrowserRouter basename="admin">
          <V2ToggleProvider>
            <App />
            <Alert />
          </V2ToggleProvider>
        </BrowserRouter>
        <GlobalStyle />
      </AppThemeProvider>
    </Provider>,
    document.getElementById("root"),
  );
} else {
  // In a frame, handle accordingly

  ReactDOM.render(
    <h1 style={{ textAlign: "center" }}>This content cannot be embedded in an iframe</h1>,
    document.getElementById("root"),
  );
}

reportWebVitals();
